import "../style/page/doctorpage.scss";
import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../maincomponent/reacttable/table";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { doctorlist, updatedoctor, doctorexcel } from "../../text/apidata";
import { useSelector, useDispatch } from "react-redux";
import { editdoctoruser } from "../redux/reducer/counterslice";
import { editdoctoruserid, sidebar } from "../redux/reducer/counterslice";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { NavLink } from "react-router-dom";
import noimage from "../../assets/images/noimage.png";
import Swal from "sweetalert2";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";

export default function Doctor(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const locationid = useSelector((state) => state.counter.loginuser_location_id)

  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [age, setAge] = React.useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const editadminuserform = useNavigate();
  const doctorcreate = useNavigate();
  const doctorview = useNavigate();
  const [branches, setbranches] = useState(locationid != "all" ? locationid : "91");

  const dispatch = useDispatch();
  const edituserdoctoridvalue = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  let roledata = localStorage.getItem("role");
  const [isactivefilterdata, setisactivefilterdata] = useState("");

  const dropdownhandlechange = (e, event) => {
    if (e) {
      editadminuserform("/DoctorCreate");
      dispatch(editdoctoruser("activedoctoredit"));
      edituserdoctoridvalue(editdoctoruserid(e));
    }
  };

  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        console.log(dtpageindex, dtpagesize);
        props.loaderchange("true");
        axios({
          method: "get",
          url: doctorlist,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            is_active: isactivefilterdata,
            location_id: branches
          },
        })
          .then((res) => {
            console.log(res.data.data.length, "aaaaaaaaaa");
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data);
            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
            props.loaderchange("false");
            // setdtPageindex(dtpageindex-1)
            props.popupalert("true");
            props.popuptext("No Data Available");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          });
      }
    } else {
      props.loaderchange("true");
      axios({
        method: "get",
        url: doctorlist,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          is_active: isactivefilterdata,
          location_id: branches
        },
      })
        .then((res) => {
          console.log(res.data.data.length, "aaaaaaaaaa");
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data);
          props.loaderchange("false");
        })
        .catch((error) => {
          console.log(error);
          props.loaderchange("false");
          // setdtPageindex(dtpageindex-1)
          props.popupalert("true");
          props.popuptext("No Data Available");
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, isactivefilterdata, branches]);

  const doctorviewclick = (e, event) => {
    doctorview("/DoctorView");
    dispatch(editdoctoruser("activedoctoredit"));
    edituserdoctoridvalue(editdoctoruserid(e));
  };
  const columns = useMemo(
    () => [
      {
        Header: "FirstName",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span style={{ display: "flex" }}>
                <img
                  style={{
                    height: "2.5rem",
                    width: "2.5rem",
                    borderRadius: "50%",
                  }}
                  onClick={(e) => {
                    window.open(
                      row.row.original.profile_pic
                        ? row.row.original.profile_pic
                        : noimage
                    );
                  }}
                  className="pointer"
                  src={
                    row.row.original.profile_pic
                      ? row.row.original.profile_pic
                      : noimage
                  }
                ></img>
                <div
                  style={{ marginTop: "9px", marginLeft: "10px", width: "100px", textWrap: "wrap" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    String(row.row.original.titles) +
                    "." +
                    String(row.row.original.first_name) +
                    " " +
                    String(row.row.original.last_name)
                  }
                  onClick={(e) => doctorviewclick(row.row.original.id, e)}
                  className="doctorname"
                >
                  {String(row.row.original.titles) +
                    "." +
                    String(row.row.original.first_name) +
                    " " +
                    String(row.row.original.last_name)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Id",
        accessor: "",
        Cell: (row) => {
          console.log(row.row.original.id)
          const shorten =
            row.row.original.id.toString().length > 20
              ? `${row.row.original.id.toString().substring(0, 10)}...`
              : `${row.row.original.id.toString()}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.id}
              >
                {shorten}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(row.row.original.id));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Experience",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.experience)}
                >
                  {String(row.row.original.experience)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Email",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.email)}
                >
                  {String(row.row.original.email)}
                </div>
              </span>
            </>
          );
        },
      },

      {
        Header: "Speciality",
        accessor: "",
        Cell: (row) => {
          const items = [];
          row.row.original.speciality.forEach((item) => items.push(item.name));
          // console.log(items.toString());
          const shorten =
            items.toString().length > 20
              ? `${items.toString().substring(0, 15)}...`
              : `${items.toString()}`;
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={`${items.toString()}`}
                >
                  {shorten + ","}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Location Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.location_id == 90 ? "CHETPET" : row.row.original.location_id == 91 ? "VELACHERY" : row.row.original.location_id == 92 ? "KOLATHUR" : ""}
              >
                {row.row.original.location_id == 90 ? "CHETPET" : row.row.original.location_id == 91 ? "VELACHERY" : row.row.original.location_id == 92 ? "KOLATHUR" : ""}              </p>
            </>
          );
        },
      },
      {
        Header: "Active",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.is_active == false ? "No" : "Yes"
                }
              >
                {row.row.original.is_active == false ? (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                ) : (
                  <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                )}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        // onChange: () => { dropdownhandlechange(e,row) },
        Cell: (row) => {
          console.log(row);
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
                {/* <button type="button" class="btn btn-danger btn-sm delete">
                <i class="bi bi-eye-fill"></i> View
                </button> */}
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const creatfunction = (e) => {
    doctorcreate("/DoctorCreate");
    dispatch(editdoctoruser("create"));
    //window.location.href = "/NewAdminUser";
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const getdata = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want to Update Data ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: updatedoctor,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Data Has Been Upadated",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((error) => { });
      }
    });
  };

  const datadownload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want To Download The Data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: doctorexcel,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            window.open(res.data.data, "_self");
            // Swal.fire(
            //   'Deleted!',
            //   'Your file has been deleted.',
            //   'success'
            // )

            console.log(res);
          })
          .catch((err) => { });
      }
    });
  };
  return (
    <>
      <div className={sideactive ? "docpage-sa" : "docpage"}>
        <div class="page-header">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Doctor</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>

                <li class="breadcrumb-item active">Doctor</li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => creatfunction(e)}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form
                  onSubmit={handleSubmit}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                    }}
                  >
                    <>
                      {/* <button
                        className="getdata"
                        onClick={(e) => {
                          getdata();
                        }}
                      >
                        <div class="spinner">
                          <i class="bi bi-chevron-double-down"></i>
                        </div>
                        Update Doctor Data
                      </button> */}

                      <div
                        align="center"
                        type="button"

                      >
                        <a class="dnbtn" onClick={(e) => {
                          datadownload();
                        }}></a>
                      </div>
                      {/* <div class="input-group rounded mr-2 "
                        style={{ width: "250px", height: "40px" }}
                      >
                        <select
                          class="form-select"
                          value={branches}
                          name="gender"
                          onChange={(e) => {
                            setbranches(e.target.value);
                          }}
                        >
                          <option selected disabled value="">
                            Filter By Location...
                          </option>
                          <option value={"90"}>CHETPET</option>
                          <option value={"91"}>VELACHERY</option>
                          <option value={"92"}>KOLATHUR</option>
                        </select>
                      </div> */}
                    </>
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    isactive={true}
                    isactivefilterdata={isactivefilterdata}
                    setisactivefilterdata={setisactivefilterdata}
                    location={"others"}
                    setbranches={setbranches}
                    branches={branches}

                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={50}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
    </>
  );
}
